import * as environments from 'src/environments.json';
const env = environments.default[process.env.REACT_APP_ENVIRONMENT.trim()];

const USE_CASE_URL = 'daily-cash-closures';

const downloadDailyCashClosureDocumentPdfByIndex = ({
  dailyCashClosureId,
  documentIndex
}) => {
  const url = `${env.api.url}/${USE_CASE_URL}/download/document?dailyCashClosureId=${dailyCashClosureId}&documentIndex=${documentIndex}`;

  window.location = url;
};

export default downloadDailyCashClosureDocumentPdfByIndex;
